import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarDireccionesExcel/descargarPlantillaExcelDireccionesExcel`, method: 'GET', body: null, token: token})
}
